/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GenerateSettlementReportByTenantOptions,
  GenerateSettlementReportByTenantResponses,
} from '../types/GenerateSettlementReportByTenant'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Generate and send settlement report for a tenant by date range.
 * {@link /v1/tenants/:tenant_id/settlements/generate}
 */
export function generateSettlementReportByTenant<ThrowOnError extends boolean = true>(
  options: Options<GenerateSettlementReportByTenantOptions, ThrowOnError>,
): Unwrappable<RequestResult<GenerateSettlementReportByTenantResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/tenants/{tenant_id}/settlements/generate',
      security: [{ type: 'http', scheme: 'bearer' }],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GenerateSettlementReportByTenantResponses, ThrowOnError>>,
  )
}
